import { getStylesObjFromCss } from "../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    root: {
      borderRadius: "20px",
      backgroundColor: "#FEFEFE",
      boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
      padding: "2px 0",
    },

    divider: {
      margin: "0 16px",
      borderBottom: "1px solid rgba(229, 229, 229, 0.6)",
    },
  },
  componentName: "SimpleSectionCTAsGroup",
});
